<template>
  <div class="deferral-query">
    <div class="lvyun-profile-banner">
      <h2>延期查询</h2>
      <p>查询顾客延期操作记录，支持按姓名、手机号、操作日期筛选与导出。</p>
    </div>

    <el-card class="action-card" shadow="never">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">延期记录列表</div>
          <div class="header-actions">
            <el-button type="default" size="small" class="btn-secondary" @click="handleExport">
              导出Excel
            </el-button>
          </div>
        </div>
      </template>

      <div class="filters-row">
        <el-input
          v-model="filters.user_name"
          placeholder="顾客姓名"
          clearable
          style="width: 160px;"
          @change="handleSearch"
        />
        <el-input
          v-model="filters.user_phone"
          placeholder="手机号"
          clearable
          style="width: 160px; margin-left: 10px;"
          @change="handleSearch"
        />
        <el-input
          v-model="filters.order_id"
          placeholder="订单 ID"
          clearable
          style="width: 140px; margin-left: 10px;"
          @change="handleSearch"
        />
        <el-select
          v-model="filters.meal_run_status"
          placeholder="订单运行状态"
          clearable
          style="width: 140px; margin-left: 10px;"
          @change="handleSearch"
        >
          <el-option label="正常运行" value="active" />
          <el-option label="已暂停" value="paused" />
        </el-select>
        <el-date-picker
          v-model="filters.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="操作开始"
          end-placeholder="操作结束"
          value-format="yyyy-MM-dd"
          style="margin-left: 10px;"
          @change="handleSearch"
        />
        <el-button type="primary" class="btn-primary" style="margin-left: 10px;" @click="handleSearch">筛选</el-button>
        <el-button class="btn-secondary" style="margin-left: 10px;" @click="resetFilters">重置</el-button>
      </div>

      <div v-if="tableData.length" class="deferral-tiles">
        <div v-for="(row, idx) in tableData" :key="row.id || idx" class="deferral-tile">
          <div class="deferral-tile-head">
            <span class="dt-date">{{ row.operation_date || '—' }}</span>
            <span class="dt-operator">{{ row.operator_name || '—' }}</span>
            <span class="dt-slot">{{ row.deferred_meal_slot || '—' }}</span>
          </div>
          <div class="deferral-tile-row">
            <span class="dt-item"><em>顾客</em>{{ row.user_name || '—' }}</span>
            <span class="dt-item"><em>电话</em>{{ row.user_phone || '—' }}</span>
            <span class="dt-item"><em>延期餐次</em>{{ row.deferred_meal_date || '—' }} {{ row.deferred_meal_slot || '' }}</span>
            <span class="dt-item dt-item--highlight"><em>顺延至</em>{{ row.new_meal_date || '—' }} {{ row.new_meal_slot || '' }}</span>
            <span class="dt-item"><em>末餐顺延至</em>{{ row.last_meal_date_after || '—' }} {{ row.last_meal_slot_after || '' }}</span>
          </div>
        </div>
      </div>
      <div v-else class="deferral-empty">暂无延期记录</div>

      <admin-pagination
        :total="pagination.total"
        :page.sync="pagination.page"
        :page-size.sync="pagination.pageSize"
        @change="onPaginationChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getAdminToken } from '../utils/auth'

export default {
  name: 'DeferralQuery',
  data() {
    return {
      filters: {
        user_name: '',
        user_phone: '',
        order_id: '',
        meal_run_status: '',
        dateRange: null
      },
      tableData: [],
      pagination: { page: 1, pageSize: 30, total: 0 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
  async fetchList() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        user_name: this.filters.user_name || undefined,
        user_phone: this.filters.user_phone || undefined,
        order_id: this.filters.order_id || undefined
      }
      if (Array.isArray(this.filters.dateRange) && this.filters.dateRange.length === 2) {
        params.date_from = this.filters.dateRange[0]
        params.date_to = this.filters.dateRange[1]
      }
      try {
        const resp = await this.$api.get('/admin/meal-schedules/deferrals', { params })
        if (resp && resp.code === 200 && resp.data) {
          this.tableData = resp.data.list || []
          this.pagination.total = resp.data.total || 0
        }
      } catch (e) {
        this.$message.error('加载延期记录失败')
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    resetFilters() {
      this.filters = { user_name: '', user_phone: '', order_id: '', meal_run_status: '', dateRange: null }
      this.handleSearch()
    },
    handlePageChange(p) {
      this.pagination.page = p
      this.fetchList()
    },
    onPaginationChange({ page, pageSize }) {
      this.pagination.page = page
      this.pagination.pageSize = pageSize
      this.fetchList()
    },
    handleExport() {
      const params = new URLSearchParams()
      if (this.filters.user_name) params.set('user_name', this.filters.user_name)
      if (this.filters.user_phone) params.set('user_phone', this.filters.user_phone)
      if (Array.isArray(this.filters.dateRange) && this.filters.dateRange.length === 2) {
        params.set('date_from', this.filters.dateRange[0])
        params.set('date_to', this.filters.dateRange[1])
      }
      const token = getAdminToken() || ''
      const base = this.$api.defaults.baseURL || '/api'
      window.open(`${base}/admin/meal-schedules/deferrals/export?${params.toString()}&token=${encodeURIComponent(token)}`, '_blank')
    }
  }
}
</script>

<style scoped>
.deferral-query {
  padding: 0 4px 24px;
}
.lvyun-profile-banner {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-radius: 12px;
  padding: 24px 28px;
  margin-bottom: 20px;
  border: 1px solid #dbeafe;
}
.lvyun-profile-banner h2 {
  margin: 0 0 8px;
  font-size: 22px;
  color: #1e293b;
}
.lvyun-profile-banner p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}
.action-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title {
  font-weight: 600;
  font-size: 16px;
}
.filters-row {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.deferral-tiles {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.deferral-tile {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  overflow: hidden;
}
.deferral-tile-head {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 14px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  overflow-x: auto;
}
.dt-date {
  font-weight: 700;
  color: #0f172a;
  font-size: 14px;
  flex-shrink: 0;
}
.dt-operator {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dt-slot {
  flex-shrink: 0;
  font-size: 12px;
  color: #059669;
  font-weight: 600;
  padding: 2px 10px;
  background: #ecfdf5;
  border-radius: 999px;
}
.deferral-tile-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  padding: 12px 14px;
  overflow-x: auto;
  white-space: nowrap;
}
.dt-item {
  flex-shrink: 0;
  font-size: 13px;
  color: #334155;
}
.dt-item em {
  font-style: normal;
  color: #94a3b8;
  margin-right: 6px;
  font-size: 12px;
}
.dt-item--highlight {
  color: #059669;
  font-weight: 600;
}
.deferral-empty {
  text-align: center;
  color: #94a3b8;
  padding: 48px 0;
  font-size: 14px;
}
</style>
